import React, { useState, useEffect } from "react";
import request from "../../services/request";
import { useParams } from "react-router-dom";
import Main from "../../components/main/Main";

export default function AnnouncementDetails(props){
    const { duyuruId } = useParams();
    const [announcement, setAnnouncement] = useState([]);

    useEffect(() => {
      getAnnouncements();
    }, []);

    const getAnnouncements = () => {
      request({
        url: "duyurular/getDetailAndMarkAsRead",
        method: "POST",
        data: {
          body: {
              id: duyuruId
          },
        },
      }).then((response) => {
        if (response.responseStatus === "SUCCESS") {
          setAnnouncement(response.body);
        }
      });
    }
    
    return (
      <>
       <Main>
                <div className="col-xl-12 col-xxl-12 col-lg-12 col-md-12">
                  <div className="post-details">
                        <h3 className="mb-3 text-black">
                          {announcement.baslik}
                        </h3>
                        <p>
                          {announcement.icerik}
                        </p>
                      </div>
                </div>
        </Main>
      </>
    );
}